<template>
  <div class="scroll-bg ei-long-figure-scroll2" :style="{width:+width+'px'}">
    <div class="scroll-l" :style="{backgroundImage: 'url('+scroll_l_img+')'}"></div>
    <div class="scroll-r" :style="{backgroundImage: 'url('+scroll_r_img+')'}"></div>
    <div class="scroll-white"></div>
    <div class="scroll-content"
         :style="{backgroundImage:'url('+imgUrl+')',animationDuration:duration+'s'}" ref="scrollContent">
    </div>
  </div>
</template>

<script>
  export default {
    name: "EiLongFigureScroll2",
    data() {
      return {
        duration: 0,
        scroll_l_img: '/upload/image/longfigure2-left.png',
        scroll_r_img: '/upload/image/longfigure2-right.png',
      }
    },
    props: {
      width: {
        type: Number,
        required: true
      },
      imgUrl: {
        type: String,
        required: true
      },
      imgWidth: {
        type: Number,
        required: true
      },
      speed: {
        type: Number,
        default: 30
      }

    },
    mounted() {
      let startX = this.width - this.imgWidth
      let endX = this.width + this.imgWidth
      this.duration = parseInt(this.imgWidth / this.speed)
      let style = document.createElement('style')
      document.getElementsByTagName('head')[0].appendChild(style)
      style.appendChild(document.createTextNode(''))
      document.styleSheets[document.styleSheets.length - 1].insertRule(`
            @keyframes scroll{
                0%{  background-position-x: ${startX}px;}
                100%{ background-position-x: ${endX}px;}
            }`)
    }
  }
</script>

<style scoped lang="scss">
  div {
    box-sizing: border-box;
  }

  .scroll-bg {
    position: relative;
    display: inline-block;
    width: 1180px;
    height: 488px;
    background-repeat: no-repeat;
    z-index: 1;
  }

  .scroll-l {
    position: absolute;
    width: 64px;
    height: 430px;
    //background-image: url("./image/longfigure2-left.png");
    background-repeat: no-repeat;
    opacity: .9;
    z-index: 3;
  }

  .scroll-r {
    position: absolute;
    right: -2px;
    width: 64px;
    height: 430px;
    //background-image: url("./image/longfigure2-right.png");
    background-repeat: no-repeat;
    opacity: .9;
    z-index: 3;
  }

  .scroll-white {
    position: absolute;
    left: 2px;
    width: 100%;
    height: 430px;
    border-radius: 10px;
    /* box-shadow: 0 0 20px 0 rgba(0, 0, 0, .6);*/
  }

  .scroll-content {
    position: absolute;
    left: 2px;
    width: 100%;
    height: 430px;
    cursor: pointer;
    overflow: hidden;
    background-repeat: repeat-x;
    background-size: auto 430px;
    animation-name: scroll;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
    animation-fill-mode: forwards;
    animation-play-state: running;
    z-index: 2;
  }

  .scroll-content:hover {
    animation-play-state: paused;
  }
</style>
